import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useMotivoDemissaoFilters
 */

type State = {
  tipoPesquisa: number;
  motivoDemissao: string;
  status: number;
};

type Action = {
  setTipoPesquisa: (tipoPesquisa: number) => void,
  setMotivoDemissao: (motivoDemissao: string) => void,
  setStatus: (status: number) => void,
};

export const useMotivoDemissaoFilters = create<State & Action>((set) => ({
  tipoPesquisa: 1,
  motivoDemissao: "",
  status: 2,
  setTipoPesquisa: (tipoPesquisa) => set({ tipoPesquisa }),
  setMotivoDemissao: (motivoDemissao) => set({ motivoDemissao }),
  setStatus: (status) => set({ status }),
}));